import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/span1.png';
import _imports_1 from '@/assets/img/span2.png';
import _imports_2 from '@/assets/img/span3.png';
import _imports_3 from '@/assets/img/span4.png';
import _imports_4 from '@/assets/img/span5.png';
const _withScopeId = n => (_pushScopeId("data-v-6897fea1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "p_home"
};
const _hoisted_2 = {
  class: "home-container-item left-top-area"
};
const _hoisted_3 = {
  class: "common-container-title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hoverChange"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}), /*#__PURE__*/_createTextVNode("设备概况")], -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "home-container-item left-bottom-area"
};
const _hoisted_7 = {
  class: "common-container-title"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hoverChange"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}), /*#__PURE__*/_createTextVNode("告警占比")], -1));
const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = {
  class: "home-container-item left-top-area"
};
const _hoisted_11 = {
  class: "common-container-title"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hoverChange"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}), /*#__PURE__*/_createTextVNode("告警排名")], -1));
const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = {
  class: "table-container"
};
const _hoisted_15 = {
  class: "id-number"
};
const _hoisted_16 = {
  class: "count-number"
};
const _hoisted_17 = {
  class: "middle-home-container"
};
const _hoisted_18 = {
  class: "home-container-item home-container-item1 left-top-area"
};
const _hoisted_19 = {
  class: "common-container-title"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hoverChange"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}), /*#__PURE__*/_createTextVNode("待处理工单")], -1));
const _hoisted_21 = [_hoisted_20];
const _hoisted_22 = {
  class: "table-container"
};
const _hoisted_23 = {
  class: "home-container-item home-container-item1 left-bottom-area"
};
const _hoisted_24 = {
  class: "common-container-title"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hoverChange"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}), /*#__PURE__*/_createTextVNode("设备告警")], -1));
const _hoisted_26 = [_hoisted_25];
const _hoisted_27 = {
  class: "table-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_device = _resolveComponent("device");
  const _component_warning = _resolveComponent("warning");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_vueSeamlessScroll = _resolveComponent("vueSeamlessScroll");
  const _component_container = _resolveComponent("container");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "container",
    style: _normalizeStyle(_ctx.bgAllImage)
  }, [_withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["common-container left-home-container", {
      'common-container1': _ctx.isDark
    }]),
    style: _normalizeStyle(_ctx.bgLeftImage)
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "title-info hover",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push({
      path: '/control/deviceManage',
      query: {
        fromMenu: 'true'
      }
    }))
  }, _hoisted_5)]), _createVNode(_component_device)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: "title-info hover",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push({
      path: '/alarmManage'
    }))
  }, _hoisted_9)]), _createVNode(_component_warning)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: "title-info hover",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.$router.push({
      path: '/alarmManage'
    }))
  }, _hoisted_13)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_el_table, {
    class: "alarm-table topTable alarm-table1 border3",
    "header-row-class-name": "home-alarm-header",
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "prop1",
      label: "排名",
      width: "60px",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "prop2",
      label: "设备编号",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "prop2",
      label: "设备位置",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "prop3",
      label: "告警次数",
      width: "100px",
      align: "center"
    })]),
    _: 1
  }), _createVNode(_component_vueSeamlessScroll, {
    data: _ctx.tableData,
    "class-option": _ctx.scrollOption,
    class: "tableScroll"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table, {
      strip: "",
      data: _ctx.tableData,
      size: "mini",
      "header-row-class-name": "home-alarm-header",
      onRowClick: _ctx.handleClick,
      class: "bottomTable alarm-table alarm-table1 border3"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        prop: "prop1",
        label: "排名",
        align: "center",
        width: "60px"
      }, {
        default: _withCtx(scope => [_createElementVNode("p", _hoisted_15, _toDisplayString(scope.$index + 1), 1)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "actNum",
        label: "设备编号",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "location",
        label: "设备位置",
        "show-overflow-tooltip": "",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        width: "100px",
        label: "告警次数",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("p", _hoisted_16, _toDisplayString(scope.row.alarmCount), 1)]),
        _: 1
      })]),
      _: 1
    }, 8, ["data", "onRowClick"])]),
    _: 1
  }, 8, ["data", "class-option"])])), [[_directive_loading, _ctx.loading1]])])], 6)), [[_directive_loading, _ctx.loading]]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_container)]), _createElementVNode("div", {
    class: _normalizeClass(["right-home-container common-container", {
      'common-container1': _ctx.isDark
    }]),
    style: _normalizeStyle(_ctx.bgRightImage)
  }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
    class: "title-info hover",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.$router.push({
      path: '/workManage'
    }))
  }, _hoisted_21)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_el_table, {
    class: "alarm-table topTable border1",
    size: "mini",
    "header-row-class-name": "home-alarm-header",
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "actNum",
      label: "设备编号",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "applyReason",
      label: "申请事由",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "applyTime",
      label: "申请时间",
      align: "center"
    })]),
    _: 1
  }), _createVNode(_component_vueSeamlessScroll, {
    data: _ctx.tableData1,
    "class-option": _ctx.scrollOption,
    class: "tableScroll"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table, {
      strip: "",
      data: _ctx.tableData1,
      "header-row-class-name": "home-alarm-header",
      onRowClick: _ctx.handleClick,
      class: "bottomTable alarm-table border1"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        prop: "actNum",
        label: "设备编号",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "applyReason",
        label: "申请事由",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "applyTime",
        label: "申请时间",
        align: "center"
      })]),
      _: 1
    }, 8, ["data", "onRowClick"])]),
    _: 1
  }, 8, ["data", "class-option"])])), [[_directive_loading, _ctx.loading3]])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
    class: "title-info hover",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.$router.push({
      path: '/alarmManage'
    }))
  }, _hoisted_26)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_el_table, {
    class: "alarm-table topTable alarm-table2 border2",
    "header-row-class-name": "home-alarm-header",
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "actNum",
      label: "设备编号",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "content",
      label: "告警内容",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "time",
      label: "告警时间",
      align: "center"
    })]),
    _: 1
  }), _createVNode(_component_vueSeamlessScroll, {
    data: _ctx.tableData2,
    "class-option": _ctx.scrollOption,
    class: "tableScroll"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table, {
      strip: "",
      data: _ctx.tableData2,
      "header-row-class-name": "home-alarm-header",
      onRowClick: _ctx.handleClick1,
      class: "bottomTable alarm-table alarm-table2 border2"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        prop: "actNum",
        label: "设备编号",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "alarmDesc",
        label: "告警内容",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "alarmTime",
        label: "告警时间",
        align: "center"
      })]),
      _: 1
    }, 8, ["data", "onRowClick"])]),
    _: 1
  }, 8, ["data", "class-option"])])), [[_directive_loading, _ctx.loading2]])])], 6)], 4), _createElementVNode("div", {
    class: "bottom-title",
    onClick: _cache[5] || (_cache[5] = (...args) => _ctx.goPage && _ctx.goPage(...args))
  })]);
}